
export enum BiShowOnMapType {
   PROPERTY = 'property',
   NEIGHBOURHOOD='neighbourhood',
   PROJECT='project'
}